 <template>
  <v-container style="width: 900px">
    <h5 v-if="timeReport.isConfirmed" class="mb-6" style="font-size: 15px; color: #fff; background-color: #f54e60; font-weight: 500; padding-top: 12px; padding-bottom: 12px; border-radius: 5px">{{ languageData.timeReportSummaryConfirmedWarningInfo }}</h5>
    <v-data-table
        :headers="headersTimeReportSummary"
        :items="items"
    >
      <template v-slot:item.savedValue="{ item }">
        <span>{{ item.type === timeReportSummaryItemsTypeEnum.find(el => el.name === 'PROFESSIONALS').value || item.type === timeReportSummaryItemsTypeEnum.find(el => el.name === 'HELPERS').value ? parseFloat(item.savedValue).toFixed(2) + 'St.' : parseFloat(item.savedValue).toFixed(2) + '€' }}</span>
      </template>
      <template v-slot:item.acceptedValue="{ item }">
        <template>
          <v-edit-dialog
              v-if="!timeReport.isConfirmed"
              large
              @save="saveAcceptedValue(item)"
              persistent
              :return-value.sync="item.acceptedValue"
          > {{ item.type === timeReportSummaryItemsTypeEnum.find(el => el.name === 'PROFESSIONALS').value || item.type === timeReportSummaryItemsTypeEnum.find(el => el.name === 'HELPERS').value ? parseFloat(item.acceptedValue).toFixed(2) + 'St.' : parseFloat(item.acceptedValue).toFixed(2) + '€' }}
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
              >
                <v-icon size="18px" color="fontDefault" class="mb-1">edit</v-icon>
              </v-btn> 
            </template>
            <span>{{ languageData.labels.edit }}</span>
          </v-tooltip>
            <template v-slot:input>
              <v-text-field
                  class="mt-5"
                  v-model="item.acceptedValue"
                  :label="'123'"
                  :rules="[v => ( v && v < 1000000000 ) || languageData.validateInvoiceItems.max_price]"
                  type="number"
                  step="0.01"
                  outlined
              ></v-text-field>
            </template>
          </v-edit-dialog>
          <span v-else>{{ item.type === timeReportSummaryItemsTypeEnum.find(el => el.name === 'PROFESSIONALS').value || item.type === timeReportSummaryItemsTypeEnum.find(el => el.name === 'HELPERS').value ? parseFloat(item.acceptedValue).toFixed(2) + 'St.' : parseFloat(item.acceptedValue).toFixed(2) + '€' }}</span>
        </template>
      </template>
      <template v-slot:item.toInvoice="{ item }">
        <template>
          <v-edit-dialog
              v-if="!timeReport.isConfirmed"
              large
              @save="saveToInvoice(item)"
              persistent
              :return-value.sync="item.toInvoice"
          > {{ item.type === timeReportSummaryItemsTypeEnum.find(el => el.name === 'PROFESSIONALS').value || item.type === timeReportSummaryItemsTypeEnum.find(el => el.name === 'HELPERS').value ? parseFloat(item.toInvoice).toFixed(2) + 'St.' : parseFloat(item.toInvoice).toFixed(2) + '€' }}
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
              >
                <v-icon size="18px" color="fontDefault" class="mb-1">edit</v-icon>
              </v-btn> 
            </template>
            <span>{{ languageData.labels.edit }}</span>
          </v-tooltip>
            <template v-slot:input>
              <v-text-field
                  class="mt-5"
                  v-model="item.toInvoice"
                  :label="'123'"
                  :rules="[v => ( v && v < 1000000000 ) || languageData.validateInvoiceItems.max_price]"
                  type="number"
                  step="0.01"
                  outlined
              ></v-text-field>
            </template>
          </v-edit-dialog>
          <span v-else>{{ item.type === timeReportSummaryItemsTypeEnum.find(el => el.name === 'PROFESSIONALS').value || item.type === timeReportSummaryItemsTypeEnum.find(el => el.name === 'HELPERS').value ? parseFloat(item.toInvoice).toFixed(2) + 'St.' : parseFloat(item.toInvoice).toFixed(2) + '€' }}</span>
        </template>
      </template>
      <template v-slot:item.value="{ item }">
        <span>{{ parseFloat(item.value).toFixed(2) + '€' }}</span>
      </template>
    </v-data-table>
    <v-card-actions class="mt-2">
      <v-row justify="end" no-gutters>        
        <v-btn
            color="primary"
            class="button-shadow"
            :loading="dataSaveIsFetching"
            @click="openConfirmTimeReportSummaryModal"
            :disabled="items.length < 1 || timeReport.isConfirmed"
        >
          <v-icon class="mr-2">mdi-arrow-right</v-icon>
          {{ languageData.labels.confirm }}
        </v-btn>
      </v-row>
      </v-card-actions>
  <ModalInfo
      v-if="languageData.confirmTimeReportSummaryModal && isShoConfirmTimeReportSummaryModal"
      @doOperation="confirmTimeReportSummary"
      :isLoadingBtn="false"
      :typeInfo="'info'"
      :headModal="languageData.confirmTimeReportSummaryModal.head"
      :btnDisAgreeText="languageData.confirmTimeReportSummaryModal.btnDisAgreeText"
      :btnAgreeText="languageData.confirmTimeReportSummaryModal.btnAgreeText"
      :visDisAgreeBtn="true" @clicked="hideConfirmTimeReportSummaryModal"
      :show-modal="isShoConfirmTimeReportSummaryModal"
      :text-modal="languageData.confirmTimeReportSummaryModal.textInfo">
  </ModalInfo>
  </v-container>
</template>

<script type="text/javascript">
import {mapState, mapActions} from 'vuex';
import TimeReportSummaryItemsType from "../../enums/TimeReportSummaryItemsType";

export default {
  name: "TimeReportSummaryItemsTable",
  props: {
    timeReport: Object,
  },
  data() {
    return {
      items: [],
      isShoConfirmTimeReportSummaryModal: false,
      timeReportSummaryItemsTypeEnum: TimeReportSummaryItemsType,
    }
  },
  computed: {
    ...mapState("getHeadersTimeReportSummary", {
      headersTimeReportSummary: state => state.headersTimeReportSummary,
    }),
     ...mapState("updateVisibleTimeReportSummaryTableModal", {
      timeReportSummaryItems: state => state.timeReportSummaryItems,
    }),
     ...mapState("confirmTimeReportSummary", {
      dataSaveIsFetching: state => state.dataSaveIsFetching,
    }),
  },
  methods: {
    ...mapActions("confirmTimeReportSummary", ["confirmTimeReportSummaryRequest"]),

    saveAcceptedValue(item) {
      let timeReportItem = this.items[this.items.indexOf(item)];
      timeReportItem.acceptedValue = item.acceptedValue;
      timeReportItem.toInvoice = item.acceptedValue;
      if (item.type === this.timeReportSummaryItemsTypeEnum.find(el => el.name === 'PROFESSIONALS').value || item.type === this.timeReportSummaryItemsTypeEnum.find(el => el.name === 'HELPERS').value) {
        this.calculateTotalValue(item)
      } else {
        timeReportItem.value = item.acceptedValue;
      }
    },
    saveToInvoice(item) {
      let timeReportItem = this.items[this.items.indexOf(item)];
      timeReportItem.toInvoice = item.toInvoice;
      if (item.type === this.timeReportSummaryItemsTypeEnum.find(el => el.name === 'PROFESSIONALS').value || item.type === this.timeReportSummaryItemsTypeEnum.find(el => el.name === 'HELPERS').value) {
        this.calculateTotalValue(item)
      } else {
        timeReportItem.value = item.toInvoice;
      }
    },
    calculateTotalValue(item) {
      switch (item.type) {
        case this.timeReportSummaryItemsTypeEnum.find(el => el.name === 'PROFESSIONALS').value:
          item.value = (parseFloat(this.timeReport.project.proffesional_hour) * parseFloat(item.toInvoice)).toFixed(2);
          break;
        case this.timeReportSummaryItemsTypeEnum.find(el => el.name === 'HELPERS').value:
          item.value = (parseFloat(this.timeReport.project.helper_hour) * parseFloat(item.toInvoice)).toFixed(2);
          break;  
        default: item.value = 0.00;
          break;
      }
    },
    openConfirmTimeReportSummaryModal() {
      this.isShoConfirmTimeReportSummaryModal = true;
    },
    hideConfirmTimeReportSummaryModal() {
      this.isShoConfirmTimeReportSummaryModal = false;
    },
    confirmTimeReportSummary() {
      this.confirmTimeReportSummaryRequest({
        items: this.items,
        timeReportId: this.timeReport.id,
      })
    }
  },
  mounted() {
    this.items = this.timeReport.timeReportSummaryItems;
  },
}
</script>